/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import Logo from "../Assets/berlietPngBlank.png";

import { HiOutlineBars3 } from "react-icons/hi2";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import {scrollingTo} from "../Assets/Functions" 
import {Link} from 'react-router-dom'


const Navbar = () => {
  const sendEmail = () => {
    var link = "mailto:berliet_hidraulicos@hotmail.com"
             + "?subject=" + encodeURIComponent("consulta")
             + "&body=Hola" 
    ;
    
    window.location.href = link;
  }
  const [openMenu, setOpenMenu] = useState(false);
  const menuOptions = [
    {
      text: "Inicio",
      icon: <HomeIcon />,
    },
    {
      text: "Servicios",
      icon: <InfoIcon />,
    },
    {
      text: "Testimonios",
      icon: <CommentRoundedIcon />,
    },
    {
      text: "Contactanos",
      icon: <PhoneRoundedIcon />,
    },
    {
      text: "Cart",
      icon: <ShoppingCartRoundedIcon />,
    },
  ];
  return (
    <nav>
      <div className="nav-logo-container">
        <img src={Logo} alt="" width={250} />
      </div>
      <div className="navbar-links-container">
        <a href="" onClick={(e) => { scrollingTo(e, "container-servicios"); }}>Servicios</a>
        <a href="" onClick={(e) => { scrollingTo(e, "container-about"); }}>Conozcanos</a>
        <a href="" onClick={(e) => { scrollingTo(e, "container-testimonial"); }}>Testimonios</a>
        <Link to='/projects' className='nav-links' >
                            Projectos
        </Link>
        
        <button className="primary-button" onClick={(e) => sendEmail()}>Contactanos ahora</button>
      </div>
      <div className="navbar-menu-container">
        <HiOutlineBars3 onClick={() => setOpenMenu(true)} />
      </div>
      <Drawer open={openMenu} onClose={() => setOpenMenu(false)} anchor="right">
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={() => setOpenMenu(false)}
          onKeyDown={() => setOpenMenu(false)}
        >
          <List>
            {menuOptions.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
        </Box>
      </Drawer>
    </nav>
  );
};

export default Navbar;
